module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "assets/3rdparty/Decoder.worker.df4e7841a75e5dde7708.js");
}
